import React from 'react';
import classNames from 'classnames';

import Selectable from 'components/focus/Selectable';

import styles from './MediaTile.module.scss';
import MediaView from './MediaView';
import { TileSize } from 'app-types';

export interface MediaTileProps {
  src?: string | null;
  className?: string | null;
  size?: TileSize | null;
  isNowPlaying?: boolean;
  focusId?: string | number | null;
  onClick?: (() => void) | null;
  onFocusSet?: (() => void) | null;
  ttsText: string;
  renderMetadata?: ((hasFocus: boolean) => React.ReactNode) | null;
  renderTitle?: ((hasFocus: boolean) => React.ReactNode) | null;
  autoSizeSrc?: boolean;
  isDvr?: boolean;
  isLive?: boolean;
}

const MediaTile = ({
  className = null,
  size = null,
  isNowPlaying = false,
  focusId = null,
  onClick = () => {},
  onFocusSet = () => {},
  ttsText,
  renderMetadata = null,
  renderTitle = null,
  autoSizeSrc = true,
  isDvr = false,
  ...rest
}: MediaTileProps) => {
  return (
    <Selectable
      onSelect={onClick}
      focusId={focusId}
      className={className}
      onFocusSet={onFocusSet}
      data-testid="media-tile"
      ttsText={ttsText}
      render={({ hasFocus }) => (
        <div
          className={classNames(
            'd-flex',
            'flex-column',
            styles[`${size}_w`],
            hasFocus ? styles.focused : styles.unfocused,
          )}
        >
          <button
            type="button"
            onClick={onClick ?? undefined}
            // Safari hides the outline if the style is applied to the internal div
            className={classNames('d-flex', 'flex-column', styles.button)}
          >
            <MediaView
              renderMetadata={renderMetadata}
              size={size}
              isNowPlaying={isNowPlaying}
              hasFocus={hasFocus}
              autoSizeSrc={autoSizeSrc}
              className={styles.hoverBorder}
              isDvr={isDvr}
              {...rest}
            />
          </button>
          {renderTitle && (
            <div
              className={classNames(
                'w-100',
                'text-white',
                'text-left',
                'mt-3',
                styles.title,
                {
                  [styles.titleFocused]: hasFocus,
                },
              )}
            >
              {renderTitle(hasFocus)}
            </div>
          )}
        </div>
      )}
    />
  );
};

export default MediaTile;
